import { uniqBy } from 'lodash';

import { EntityEnum } from '../../definitions/enums/Entity';
import { BlockNumberType } from '../../definitions/types/BlockNumber';
import { EntityType } from '../../definitions/types/Entity';
import { SelectedEntityType } from '../../definitions/types/SelectedEntityType';
import { StateType } from '../../definitions/types/StateType';
import { SEARCH_URL } from '../constants/SEARCH_URL';
import { urlFromState } from './urlFromState';

interface IStateFromUrl {
  url: string;
  state?: StateType;
  workspaceClearUrl?: string;
}

export const stateFromUrl = ({
  url,
  state,
  workspaceClearUrl,
}: IStateFromUrl): StateType => {
  const search = url
    .replace(/^[^?]*\?/, '') // remove everything up to and including ?
    .replace(/#[^#]*$/, ''); // remove any #partial at the end of the url
  const entities: string = new URLSearchParams(search).get('entities') || '';
  const selected: string = new URLSearchParams(search).get('selected') || '';
  let parsedSelected: SelectedEntityType | null = {
    type: selected.split(':')[0] as EntityEnum,
    id: selected.split(':')[1],
    number: '1',
  };
  const labelLookup: Record<string, string | undefined> = {};
  const identifierLookup: Record<string, string | undefined> = {};

  if (state?.entities?.length) {
    state.entities.forEach((entity) => {
      labelLookup[entity.id] = entity.label;
      identifierLookup[entity.id] = entity.identifierType;
    });
  }

  let parsedEntities: EntityType[] = [];
  if (entities) {
    parsedEntities = entities
      .split(',')
      .map((entity: string, index: number): EntityType => {
        const type = entity.split(':')[0] as EntityEnum;
        const id = entity.split(':')[1];
        const label = labelLookup[id];
        const identifierType = identifierLookup[id];
        if (
          parsedSelected &&
          parsedSelected.type === type &&
          parsedSelected.id === id
        ) {
          parsedSelected.number = `${index + 1}` as BlockNumberType;
        }
        return { type, id, label, identifierType };
      });
  }

  if (!parsedSelected.type) {
    if (parsedEntities.length) {
      parsedSelected = {
        ...parsedEntities[0],
        number: '1',
      };
    } else {
      parsedSelected = null;
    }
  } else {
    parsedSelected.label = labelLookup[parsedSelected.id];
  }

  const parsedState = {
    entities: uniqBy(parsedEntities, 'id'),
    workspaceClearUrl:
      state?.workspaceClearUrl || workspaceClearUrl || SEARCH_URL,
    selected: parsedSelected,
    url: '',
  };

  parsedState.url = urlFromState(parsedState);

  return parsedState;
};
